define(function (require) {

    // TODO: WIP.
    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.App = window.App || {};

    var BaseController = require('web-agent-assets-js/BaseController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////

    var logger;
    var availabilityTypesInAMS = {
        ONLINE: "ONLINE",
        AWAY: "AWAY",
        BACK_SOON: "BACK_SOON"
    };
    var availabilityTypesReceived = {
        ONLINE: "Online",
        AWAY: "Away",
        BACK_SOON: "Occupied"
    };

    var statusChangeRetryCounter = 0;
    var statusChangeRetryTimerInterval = 3000; // 3 sec
    var statusChangeRetryTimerId = null;
    var statusChangeTimeoutTimerInterval = 5000; // 5 sec
    var statusChangeTimeoutTimerId = null;
    /////////////////////////////////// INITIALIZATION ///////////////////////////////////

    var agentStatusController = BaseController.extend(function lpAMSAgentStatusController(options) {
        logger = this.logger;

        /**
         * LE-80394: Transitation with agent reason reported twice to the server.
         * adding a debouncer for the availability change triggers, because they are not fired in the same model,
         * we debound to the lates, the updateAMSAvailability will read the current state when invoked.
         * only one call we be maed instead of two.
         */
        var handleAvailabilityChange = _.debounce(this.updateAMSAvailability,1);

        // subscription for appServer changes- upon changes, update AMS
        this.model.bind("agent.chatAvailability", handleAvailabilityChange, this);
        this.model.bind("agent.chatReasonId", handleAvailabilityChange, this);

    });

    agentStatusController.prototype.applicationType = "lpAMSAgentStatusController";

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////

    /**
     * Set new time interval to statusChangeRetryTimerInterval
     * @param interval - milliseconds
     */
    agentStatusController.prototype.setRetryTimerInterval = function(interval) {
        if(interval && interval > 0) {
            statusChangeRetryTimerInterval = interval;
        }
    };

    /**
     * Set new time interval to statusChangeTimeoutTimerInterval
     * @param interval - milliseconds
     */
    agentStatusController.prototype.setTimeoutTimerInterval = function(interval) {
        if(interval && interval > 0) {
            statusChangeTimeoutTimerInterval = interval;
        }
    };

    /**
     * Subscribing to Agent Status Change.
     */
    agentStatusController.prototype.subscribeToAgentStatusChange = function () {
        var brandId = this.model.get('agent.lpNumber');
        var agentId = this.model.get('agent.messagingUserId');

        var payload = {
            brandId: brandId,
            agentId: agentId,
            success: function (data) {
                logger.info("Successfully subscribed to AMS for agent status changes");
            },
            error: function (errorData) {
                logger.error("Could not subscribe to AMS for agent status changes");
                logger.graph({name: 'subscribeAgentStateError'});
            }
        };
        lpTag.WebAgent.amsConnectionController.amsClient.subscribeAgentStatusUpdates(payload);
    };

    /**
     * Updating the UMS with the current Chat Availability.
     */
    agentStatusController.prototype.updateAMSAvailability = function () {
        var agentId = this.model.get('agent.messagingUserId');
        var chatAvailability = this.model.get("agent.chatAvailability");
        var chatReasonId = this.model.get("agent.chatReasonId");
        var isConnected = lpTag.WebAgent.amsConnectionController.connectionState === lpAMSController.SOCKET_STATES.CONNECTED;
        var diagnostics = window.lpTag.WebAgent.logicController && window.lpTag.WebAgent.logicController.diagnostics;

        if(isConnected){
            if (agentId && chatAvailability) {
                var payload = {
                    agentUserId: agentId,
                    availability: _formatAvailabilityForQueryInAMS(chatAvailability),
                    metadata: (chatReasonId && chatReasonId !== -1) ? [{"type":"ActionReason","reasonId": '' + chatReasonId, "reason": ""}] : null, //the reasonId sent as string ,the reason is sent only because it's a mandatory field for the ums
                    success: function (data) {
                        _clearStatusChangeTimeout();
                        logger.info("Successfully updated agent status");
                        statusChangeRetryCounter = 0;
                        if (diagnostics && diagnostics.isKeyActive(diagnostics.keys.updateAMSAvailabilitySuccess)) {
                            logger.error('DIAGNOSTICS: Successfully updated agent status');
                            logger.graph({name: 'diagnostics:updateAMSAvailabilitySuccess'});
                        }
                    },
                    error: function (errorData) {
                        _clearStatusChangeTimeout();
                        logger.error("Could not update agent status. Retry counter = " + statusChangeRetryCounter + ', messagingUserId = ' + agentId);
                        logger.graph({name: 'setAgentStateError'});
                        if (statusChangeRetryTimerId == null) {
                            statusChangeRetryCounter++;
                            // start a retry-once timer
                            statusChangeRetryTimerId = setTimeout(function () {
                                lpTag.WebAgent.amsAgentStatusController.updateAMSAvailability();
                            }, statusChangeRetryCounter * statusChangeRetryTimerInterval);
                        }
                    }
                };
                // stop the retry timer, for case that the success return from a different update call
                if (statusChangeRetryTimerId !== null) {
                    clearTimeout(statusChangeRetryTimerId);
                    statusChangeRetryTimerId = null;
                }
                _clearStatusChangeTimeout();
                statusChangeTimeoutTimerId = setTimeout(function () {
                    // This timeout is for the event that we receive no answer from UMS (no success and no error).
                    // We want to make sure that we retry so that UMS is updated with the correct status
                    logger.error('Agent status update timed out. Retry counter = ' + statusChangeRetryCounter + ', messagingUserId = ' + agentId);
                    logger.graph({name: 'setAgentStateTimeout'});
                    statusChangeRetryCounter++;
                    lpTag.WebAgent.amsAgentStatusController.updateAMSAvailability();
                }, statusChangeTimeoutTimerInterval);
                lpTag.WebAgent.amsConnectionController.amsClient.setAgentStatus(payload);
            } else {
                logger.error("Could not update agent status. missing information [ agentId: " + agentId + " , chatAvailability: " + chatAvailability + " , chatReasonId: " + chatReasonId + "]");
                logger.graph({name: 'updateAMSAvailability'});
            }
        } else if (diagnostics && diagnostics.isKeyActive(diagnostics.keys.updateAMSAvailabilityNotConnected)) {
            logger.error('DIAGNOSTICS: Did not update availability because web socket is not connected');
            logger.graph({name: 'diagnostics:updateAMSAvailabilityNotConnected'});
        }


    };

    /**
     * Clears the timeout for changing the status.
     * This timeout is for the event that we receive no answer from UMS (no success and no error).
     * We want to make sure that we retry so that UMS is updated with the correct status
     * @private
     */
    function _clearStatusChangeTimeout() {
        if (statusChangeTimeoutTimerId) {
            clearTimeout(statusChangeTimeoutTimerId);
            statusChangeTimeoutTimerId = null;
        }
    }

    /**
     * Transforming AppServer State of the Availability To UMS Format.
     * @param data
     * @returns {*}
     * @private
     */
    function _formatAvailabilityForQueryInAMS(data) {
        var localData = data;
        if (data) {
            switch (localData) {
                case availabilityTypesReceived.ONLINE :
                    localData = availabilityTypesInAMS.ONLINE;
                    break;
                case availabilityTypesReceived.BACK_SOON :
                    localData = availabilityTypesInAMS.BACK_SOON;
                    break;
                case availabilityTypesReceived.AWAY :
                    localData = availabilityTypesInAMS.AWAY;
                    break;
                default:
                    localData.toUpperCase();
            }
            return localData;
        }
    }


    return agentStatusController;

});
